import {
    SkyNetTableConfig, RangeType, SkyNetTableField, injectFieldsToTabs,
} from 'app/shared-components/SkyNetTable'
import {
    FilterType,
    CommonRoutes,
} from 'app/enums/common.enums'
import {
    SkyNetTableTab,
} from 'app/shared-components/SkyNetTable/types/skyNetTable.types'

import {
    LoggerStatus, LoggerMode,
} from 'app/enums/label.enums'
import {
    convertFromFilterDaysDate,
    convertFromFilterDaysValue, convertToFilterDaysDate,
    convertToFilterDaysValue, parseFromFilterDaysDate,
    parseFromFilterDaysValue, parseToFilterDaysDate,
    parseToFilterDaysValue,
} from 'app/utils/date'

import LoggerType, {
    LoggerTable,
} from './Loggers.types'

const nameColumn: SkyNetTableField<keyof LoggerTable>[] = [
    {
        name: 'loggerNumber',
        reduced: true,
    },
    {
        name: 'loggerType',
        componentName: 'EnumValue',
        allowedValuesEnum: LoggerType,
        filterField: 'loggerType',
        filterType: FilterType.Array,
    },
]
const stateColumn: SkyNetTableField<keyof LoggerTable> = {
    name: 'loggerStatus',
    componentName: 'EnumValue',
    allowedValuesEnum: LoggerStatus,
    filterField: 'loggerStatus',
    filterType: FilterType.Array,
}
const otherColumns: SkyNetTableField<keyof LoggerTable>[] = [
    {
        name: 'loggerMode',
        componentName: 'EnumValue',
        labelKey: 'Logger.loggerMode',
        allowedValuesEnum: LoggerMode,
        filterField: 'loggerMode',
        filterType: FilterType.Array,
        sorting: false,
    },
    {
        name: 'locationName',
        filterField: 'locationName',
        labelKey: 'Logger.lastLocation',
        filterType: FilterType.Array,
    },
    {
        name: 'gatewayImeiMac',
        filterField: 'gatewayImeiMac',
        filterType: FilterType.Array,
        labelKey: 'Gateway.gatewayImeiMac',
        sorting: false,
    },
    {
        name: 'productionBatchNumber',
        filterField: 'productionBatchNumber',
        filterType: FilterType.Array,
        labelKey: 'Logger.productionBatchNumber',
    },
    {
        name: 'containerSerialNumber',
        sorting: false,
    },
    {
        name: 'isTestingLogger',
        filterField: 'isTestingLogger',
        labelKey: 'Logger.isTestingLogger',
        filterType: FilterType.Array,
        componentName: 'ChipCheckMark',
        sorting: false,
    },
    {
        name: 'lastMeasuredOnUtc',
        componentName: 'TemperatureAge',
        rangeType: RangeType.DayRange,
        filterField: 'lastMeasuredOnUtc',
        filterType: FilterType.IntegerRange,
        filterOptions: {
            labels: {
                from: 'More or Equal (Days)',
                to: 'Less Then (Days)',
            },
            convert: {
                from: convertFromFilterDaysValue,
                to: convertToFilterDaysValue,
            },
            parse: {
                from: parseFromFilterDaysValue,
                to: parseToFilterDaysValue,
            },
        },
    },
    {
        name: 'batteryVoltage',
        sorting: false,
    },
    {
        name: 'hardwareVersion',
        filterField: 'hardwareVersion',
        filterType: FilterType.Array,
    },
    {
        name: 'softwareVersion',
        filterField: 'softwareVersion',
        filterType: FilterType.Array,
    },
    {
        name: 'rentingCompany',
        labelKey: 'Logger.rentingCompany',
        sorting: false,
        filterField: 'rentingCompany',
        filterType: FilterType.Array,
    },
    {
        name: 'createdOn',
        componentName: 'LoggerAgeFromDate',
        labelKey: 'ContainerView.loggerExchangedOnUtcAmbient',
        rangeType: RangeType.DayRange,
        filterField: 'createdOn',
        filterType: FilterType.IntegerRange,
        filterOptions: {
            labels: {
                from: 'More or Equal (Days)',
                to: 'Less Then (Days)',
            },
            convert: {
                from: convertFromFilterDaysDate,
                to: convertToFilterDaysDate,
            },
            parse: {
                from: parseFromFilterDaysDate,
                to: parseToFilterDaysDate,
            },
        },
    },
    {
        name: 'lastActivatedOn',
        componentName: 'LoggerLastActivated',
        labelKey: 'Logger.lastActivatedOn',
    },
]
const defaultFields: SkyNetTableField<keyof LoggerTable>[] = [
    ...nameColumn,
    ...[stateColumn],
    ...otherColumns,
]

const excludeTab: SkyNetTableTab<keyof LoggerTable> = {
    name: 'Excluded',
    url: CommonRoutes.Excluded,
    requestUrl: 'all',
    includeFilters: {
        loggerStatus: [LoggerStatus.DECOMMISSIONED],
    },
    fields: [
        ...nameColumn,
        ...otherColumns,
    ],
}

const config: SkyNetTableConfig<keyof LoggerTable> = {
    name: 'LoggersTable',
    tabs: injectFieldsToTabs<keyof LoggerTable>([
        {
            name: 'All Loggers',
            url: CommonRoutes.All,
            filters: {
                loggerStatusExcluded: [LoggerStatus.DECOMMISSIONED],
            },
        },
        excludeTab,
    ], defaultFields),
}

export default config
